import { Type } from "class-transformer";
import { IsDate, IsBoolean } from "class-validator";
import { AbstractJSONModel } from "./master-model";

export enum MainDepartment {
  VUGGESTUE = "vuggestue",
  BØRNEHAVE = "børnehave",
  DAGPLEJE = "dagpleje",
  SFO = "sfo",
  KLUB = "klub"
}

export interface IDepartmentPost {
  id: number;
  name: string;
  institution_id: number;
  is_active: boolean;
  color: string;
  icon_name: string;
  main_department?: MainDepartment;
}

export interface IDepartmentPut {
  id: number;
  name: string;
  is_active: boolean;
  color: string;
  icon_name: string;
  main_department?: MainDepartment;
}

export interface IDepartment {
  id: number;
  name: string;
  /**
   * The department's id in the source system (UUID). Read-only here — it is set
   * by the municipality import, and is what child presence data from ComeGo is
   * matched on (ComeGo's `afdeling`). Null for departments created in DTP.
   */
  external_id: string | null;
  institution_id: number;
  created_at: Date;
  updated_at: Date;
  is_active: boolean;
  color: string;
  icon_name: string;
  main_department?: MainDepartment;
  has_duties: boolean;
}

export class Department extends AbstractJSONModel implements IDepartment {
  public id = -1;
  public name = "";
  public external_id: string | null = null;
  public institution_id = -1;
  @IsDate()
  @Type(() => Date)
  public created_at: Date = new Date();
  @IsDate()
  @Type(() => Date)
  public updated_at: Date = new Date();
  @IsBoolean()
  public is_active = true;
  public color: string = "#000000";
  public icon_name: string = "circle";
  public main_department?: MainDepartment;
  public has_duties = false;

  public equals(other: IDepartment): boolean {
    return other.id === this.id;
  }

  public convertToPutObject(): IDepartmentPut {
    const d: IDepartmentPut = Object.assign({});
    d.id = this.id;
    d.name = this.name;
    d.is_active = this.is_active;
    d.color = this.color;
    d.icon_name = this.icon_name;
    d.main_department = this.main_department;
    return d;
  }
}
